import type { OnInit } from '@angular/core';
import { ChangeDetectorRef, Component, NgZone } from '@angular/core';
import type { NavigationExtras } from '@angular/router';
import { ActivatedRoute, Router } from '@angular/router';
import { BLE } from '@awesome-cordova-plugins/ble/ngx';
import { Geolocation } from '@awesome-cordova-plugins/geolocation/ngx';
import {
  BleClient,
  numbersToDataView,
  numberToUUID,
  RequestBleDeviceOptions,
  ScanMode,
  ScanResult,
} from '@capacitor-community/bluetooth-le';
import { App } from '@capacitor/app';
import {
  AlertController,
  LoadingController,
  ModalController,
  NavController,
  NavParams,
  Platform,
} from '@ionic/angular';
import { Storage } from '@ionic/storage';
import { TranslateService } from '@ngx-translate/core';
import * as _ from 'lodash-es';
import { OpenService } from 'src/app/bluetooth/cmd/open.service';
import { ConnexionService } from 'src/app/bluetooth/connexion.service';
import { RequiermentService } from 'src/app/bluetooth/requierment.service';
import { RayoBleService } from 'src/app/services/bluetooth/rayonics/rayoble.service';
import { RayoBleKeyService } from 'src/app/services/bluetooth/rayonics/rayoblekey.service';
import { UlinkBleService } from 'src/app/services/bluetooth/ulink/ble.service';

import { AccessControllerService, SiteDeviceControllerService } from '../../shared/typescript-angular-client';

import { DeviceControllerService } from './../../shared/typescript-angular-client/api/deviceController.service';
import { DeviceTaskControllerService } from './../../shared/typescript-angular-client/api/deviceTaskController.service';
import { HelpModalPage } from './help-modal/help-modal.page';

@Component({
  selector: 'app-sync',
  templateUrl: './sync.component.html',
  styleUrls: ['./sync.component.scss'],
})
export class SyncComponent implements OnInit {
  from: any;
  step: number = 0;
  status: number = 0;
  siteId: any;
  siteDevices: any = [];
  newDevices: any = [];
  devices: any = [];
  deviceID: any = null;
  searching: any;
  public isConnected: boolean = false;
  helpVisible = false;
  public mustSync = false;
  userAccesses: any = [];

  userInfo: any;
  userSite: any;
  userRole: boolean = false;

  bleService: any;

  syncQueue = [];
  syncing: boolean = false;
  public autoSync: boolean;
  // public syncError: boolean;
  device: any;
  public installMode: boolean = false;
  public syncWithoutTasks: boolean;
  public syncWithoutTasksSince: number;
  public orderAuto: boolean = false;

  public bleClient = BleClient;
  displayBattery: any;

  constructor(
    private navParams: NavParams,
    private activatedRoute: ActivatedRoute,
    private deviceTaskApi: DeviceTaskControllerService,
    private deviceApi: DeviceControllerService,
    private ble: BLE,
    private navCtrl: NavController,
    public siteDeviceApi: SiteDeviceControllerService,
    public accessApi: AccessControllerService,
    private changeRef: ChangeDetectorRef,
    private loadCtrl: LoadingController,
    private modalCtrl: ModalController,
    private alertCtrl: AlertController,
    private bleRequirement: RequiermentService,
    private bleConnexion: ConnexionService,
    private cmdOpen: OpenService,
    private storage: Storage,
    private gps: Geolocation,
    private router: Router,
    private modalController: ModalController,
    private ulinkBleService: UlinkBleService,
    private rayoBleService: RayoBleService,
    private rayoBleKeyService: RayoBleKeyService,
    public platform: Platform,
    private translate: TranslateService,
    private zone: NgZone
  ) {}

  async ngOnInit(): Promise<void> {
    App.addListener('backButton', () => {
      this.back();
    });
    try {
      await this.bleClient.initialize();
      console.log('Sync component - BLE initialized');
    } catch (e) {
      console.log('Sync component - error while initializing BLE:', e);
    }
    await this.bleClient.stopLEScan();
    this.userInfo = await this.storage.get('userInfos');

    console.log(this.userInfo);
    this.getAccesses();
    this.from = this.navParams.get('from');
    this.siteId = this.navParams.get('id');
    this.deviceID = this.navParams.get('deviceID');

    this.installMode = this.navParams.get('installMode');

    //Should we launch sync automatically at scan startup?
    this.autoSync = this.userInfo?.preferences?.sync?.auto ?? true;
    //Should we sync devices without pending tasks (to sync battery, events, etc)?
    this.syncWithoutTasks = this.userInfo?.preferences?.sync?.withoutTasks ?? true;
    //Sync devices without tasks only if they was not sync since following delay (24h default)
    this.syncWithoutTasksSince = this.userInfo?.preferences?.sync?.withoutTasksSince ?? 24 * 3600 * 1000;
    /*if (this.userInfo.permissions.sites[this.siteId].role == "user")
      this.userRole = true;*/
    //Should we display battery icon?
    this.displayBattery = this.userInfo?.preferences?.sync?.displayBattery ?? true;
    console.log('NgOnInit. Devices:', this.devices);
    this.getDevices();
  }

  async ngOnDestroy(): Promise<void> {
    console.log('syncModal - ngOnDestroy');
    // this.ble.stopScan();
    await this.bleClient.stopLEScan();
    // this.devices.forEach((device) => {
    //   if (device.isConnected) {
    //     if (device['rc']) {
    //       this.bleService = this.rayoBleService;
    //     } else {
    //       this.bleService = this.ulinkBleService;
    //     }
    //     this.bleService.initDevice(device, this.ble);
    //     this.bleService.disconnect();
    //   }
    // });
    await this.disconnectBleDevices();
    this.devices = [];
    this.syncQueue = [];
    App.removeAllListeners();
  }

  public async presentHelpModal(): Promise<any> {
    let modal: any;
    modal = await this.modalController.create({
      component: HelpModalPage,
    });

    // await this.storage.set('checkGps', true);

    return await modal.present();
  }

  async getDevices(): Promise<void> {
    this.devices = [];
    // this.changeRef.detectChanges();
    this.searching = true;

    // await this.getCacheDevices();
    this.getCacheDevices();
    this.getCacheScanDevices();
    if (this.siteDevices.filter((d) => d.properties.model === 'solupass_cylinder').length > 0) {
      this.helpVisible = true;
    }
    this.bleScan();
    // Get user devices and do BLE Scan
    this.siteDeviceApi.siteDeviceControllerFindAll().subscribe({
      next: async (data: any[]) => {
        // if API responds, store devices list in cache
        console.log('using API devices:', data);
        this.siteDevices = data;
        if (this.siteDevices.filter((d) => d.properties.model === 'solupass_cylinder').length > 0) {
          this.helpVisible = true;
          this.storage.get('checkScanHelp').then((d) => {
            if (!d) {
              this.presentHelpModal();
            }
          });
        } else {
          this.helpVisible = false;
        }
        // this.changeRef.detectChanges();

        const body = {
          expire: Math.floor(new Date().getTime() / 1000) + 600,
          value: data,
        };

        console.log('Body : ', body);

        await this.storage.set('devices', body);

        // this.changeRef.detectChanges();

        // this.bleScan();
      },
      error: async () => {
        //If API couldnt be reached, use cache data or display an error
        if (!(await this.getCacheDevices())) {
          //Error message?
          console.log('connexion réseau perdue');
        }
      },
    });
  }

  async getAccesses(): Promise<void> {
    // this.devices = [];
    // this.changeRef.detectChanges();

    await this.getCacheAccesses();
    // Get user accesses
    this.accessApi.accessControllerFindUserEmailAccesses().subscribe({
      next: async (data: any[]) => {
        // if API responds, store accesses list in cache
        console.log('using API accesses:', data);
        this.userAccesses = data.filter((a) => {
          if (a.properties !== null && a.properties !== '{}') {
            return a.properties.endDate >= new Date().toISOString();
          }
        });
        // this.changeRef.detectChanges();

        const body = {
          expire: Math.floor(new Date().getTime() / 1000) + 600,
          value: data,
        };

        console.log('Body : ', body);

        await this.storage.set('accesses', body);

        // this.changeRef.detectChanges();

        this.bleScan();
      },
      error: async () => {
        //If API couldnt be reached, use cache data or display an error
        if (!(await this.getCacheDevices())) {
          //Error message?
          console.log('connexion réseau perdue');
        }
      },
    });
  }

  // Get cache devices
  // return true if ok, false if no data cached or cached data expired
  private async getCacheDevices(): Promise<boolean> {
    return new Promise(async (resolve) => {
      const cachedData = await this.storage.get('devices');
      let cb = false;
      console.log('using Cached devices:', cachedData);

      if (cachedData != null && Math.floor(new Date().getTime() / 1000) < cachedData['expire']) {
        this.siteDevices = cachedData['value'];

        console.log('VALUE : ', this.siteDevices);
        // this.changeRef.detectChanges();

        cb = true;
      }
      resolve(cb);
    });
  }

  // Get cache devices
  // return true if ok, false if no data cached or cached data expired
  private async getCacheScanDevices(): Promise<boolean> {
    return new Promise(async (resolve) => {
      const cachedData = await this.storage.get('scanDevices');
      let cb = false;
      console.log('using Cached scan devices:', cachedData);

      if (cachedData != null && Math.floor(new Date().getTime() / 1000) < cachedData['expire']) {
        this.devices = cachedData['value'];

        console.log('VALUE : ', this.devices);
        // this.changeRef.detectChanges();

        // this.bleScan();
        cb = true;
      }
      resolve(cb);
    });
  }

  // Get cache devices
  // return true if ok, false if no data cached or cached data expired
  private async getCacheAccesses(): Promise<boolean> {
    return new Promise(async (resolve) => {
      const cachedData = await this.storage.get('accesses');
      let cb = false;
      console.log('using Cached accesses:', cachedData);

      if (cachedData != null && Math.floor(new Date().getTime() / 1000) < cachedData['expire']) {
        this.userAccesses = cachedData['value'];

        console.log('VALUE : ', this.userAccesses);
        // this.changeRef.detectChanges();

        this.bleScan();
        cb = true;
      }
      resolve(cb);
    });
  }

  async bleScan() {
    console.log('Start Ble Scan. Devices list:', this.devices);
    if (!this.bleRequirement.checkRequierment()) {
      this.searching = false;
      // this.changeRef.detectChanges();
      return;
    } else {
      setTimeout(() => {
        this.searching = false;
        // this.changeRef.detectChanges();
      }, 601000);
      this.startScan();
      if (this.platform.is('android')) {
        //Get GPs location
        console.log('Syncomponent - BleScan - Android - Searching gps location...');
        this.gps
          .getCurrentPosition({ maximumAge: Infinity, timeout: 10000 })
          .then((resp) => {
            console.log('Syncomponent - BleScan - Got location: ', resp);
          })
          .catch(async (error) => {
            console.log('Error getting location', error);
            // this.ble.stopScan();
            this.bleClient.stopLEScan();
            //Handle permission error => wait until user authorizes location and
            //start scan again
            if (error.code && error.code === 2) {
              //Wait 10seconds and check again location authorization status
              setTimeout(async () => {
                const isLocationAuthorized = await this.bleRequirement.checkLocationAuthorization();
                if (isLocationAuthorized) {
                  console.log('Location authorization ok');
                  this.startScan();
                } else {
                  //Force new location authorization request and restart scan
                  this.bleRequirement
                    .requestLocationAuthorization()
                    .then(() => {
                      this.bleScan();
                    })
                    .catch((err) => console.log(err));
                }
              }, 10000);
            } else {
              console.log('Unhandled location error');
            }
          });
      }
    }
  }

  async startScan(): Promise<void> {
    await this.bleClient.stopLEScan();
    //Start BLE scan
    //restart scan every 10s to refresh devices
    setTimeout(async () => {
      this.modalCtrl.getTop().then(async (modal) => {
        //if modal if dismissed, dont restart scan
        if (modal && modal !== undefined) {
          // await this.ble.stopScan();
          // this.bleScan();
          return;
        }
      });
      // if(this.devices.length <= 0) return this.startScan();
    }, 10000);
    const scanOptions: RequestBleDeviceOptions = { allowDuplicates: false, scanMode: ScanMode.SCAN_MODE_BALANCED };
    const scanCallback = (result: ScanResult) => {
      this.zone.run(() => {
        console.log('Sync component - scanCallback - result:', result);
        // const advName = device.advertising.kCBAdvDataLocalName;
        const advName = result.localName;
        let device = result.device;
        console.log('Sync component - scanCallback - zone run, advName:', advName, 'device:', device);
        if (advName?.includes('U-Link') || device.name?.includes('U-Link')) {
          this.addDeviceToList(device, 'ulink', advName, result.rssi);
        } else if (
          (advName != null && (advName.includes('RC') || advName.includes('RD'))) ||
          (device.name != null &&
            (device.name.includes('RC') || device.name.includes('RD')))
        ) {
          // console.log('A');
          // this.addDeviceToListRC(device);
          this.addDeviceToList(device, 'rayonics', advName, result.rssi);
        } else if (!advName && device && !device.name) {
          console.log('Sync component - scanCallback - no device name returned for id:', device.deviceId);
          //search device with mac;
        }
      });
    };
    await this.bleClient.requestLEScan(scanOptions, scanCallback);
  }

  enableAutoSyncOnce(): void {
    this.autoSync = true;
    this.refresh();
  }

  async viewDetail(device) {
    await this.disconnectBleDevices();
    if (this.isAdmin(device) == false) {
      // this.open(device);
    } else {
      await this.storage.set('device', device);
      let navigationExtras: NavigationExtras = {
        queryParams: {
          isConnected: this.isConnected,
          openDoor: false,
          // device: JSON.stringify(device),
          deviceId: device.id,
          bleId: device.bleId,
          auto_connect: true,
          replaceUrl: true,
        },
      };

      if (device['rc']) {
        console.log(device);
        if (device.serialNumber.match(/^B0/)) {
          // if(device.advertising.kCBAdvDataLocalName.includes('B0') || device.name.includes('B0')) {
          console.log('Rayonics BLE Key');
          this.bleService = this.rayoBleKeyService;
          await this.bleService.initDevice(device, this.bleClient);
          try {
            await this.bleService.connect();
            // await this.bleService.rayAuthNew();
            this.isConnected = this.bleService.isConnected;
          } catch (err) {
            console.log('Sync - Error while connecting to device:', err);
            this.isConnected = false;
            device.status = 'DEVICEBLE.CONNECTION.ERROR';
          }
          console.log('this.isConnected', this.isConnected);
          device.isConnected = this.isConnected;
          this.saveDevice(device);
          if (this.isConnected) {
            console.log('Sync - device is connected, subcribe to disconnect sub');
            this.bleService.connectSubject.subscribe((res) => {
              console.log('Sync - Deconnexion subject:', res);
              if (this.bleService.taskAction === 'params') {
                //handle Bt connection loss following a firware update or reset cmd
                console.log('Syncomponent - connectSubject - lost connection after reset');
              } else {
                //reconnect??
                this.bleDisconnected(this.device);
              }
            });
          }
          return;
        }
        if (this.userInfo.permissions.sites[device['siteId']].role != 'user') {
          // console.log('a');
          console.log(device);
          this.storage.set('fromScan', true).then(() => {
            this.modalCtrl.dismiss();
            this.router.navigate(['site/' + device.siteId + '/device/rayonics/' + device.id], navigationExtras);
          });
        }

        console.log('Ouverture Rayonics');

        return;
      }

      // localStorage.setItem('device', JSON.stringify(device));

      this.storage.set('fromScan', true).then(() => {
        this.modalCtrl.dismiss().then(() => {
          this.router.navigate(['site/' + device.siteId + '/device/detail/' + device.id], navigationExtras);
        });
      });
    }
  }

  async addDeviceToList(device: any, type = 'ulink', advName: string, rssi: number = null): Promise<void> {
    let mac;
    let find = false;
    if (type === 'rayonics') {
      mac = device.name;
    } else {
      mac = device.deviceId.substring(0, 8) + 'FFFE' + device.deviceId.substring(8, 17);
      mac = mac.replace(new RegExp(':', 'g'), '');
    }
    // console.log('mAC : ', mac);

    // for (let i = 0; i < this.siteDevices.length; i++) {
    for (const siteDevice of this.siteDevices) {
      // const siteDevice = this.siteDevices[i];
      // console.log('siteDevice : ', siteDevice);
      const sn = siteDevice['serialNumber'];
      const truncSn = sn.substring(sn.length - 4, sn.length);
      // const advName = device.advertising.kCBAdvDataLocalName;

      // console.log('SN : ', sn, ' -----', truncSn, '-------', advName);
      let avdCondition;
      if (type === 'rayonics') {
        avdCondition = advName && sn == advName;
      } else {
        avdCondition = advName?.includes(truncSn);
      }

      if (sn == mac || avdCondition) {
        console.log('Found matching', type, 'device:', siteDevice);
        find = true;
        //Avoid adding same device twice
        const idx = this.devices.findIndex((d) => d.id === siteDevice.id);
        // if (idx >= 0) continue;
        // if (idx >= 0) {
        //Refresh signal
        // this.devices[idx].signal = device.rssi;
        // this.devices[idx].signalIcon = this.getSignal(device.rssi);
        // this.saveDevice(this.devices[idx]);
        // }
        // console.log('Device not in list, add it');
        console.log(
          'Add or refresh device in list:'
          // JSON.stringify(this.devices)
        );
        // siteDevice['bleId'] = device.id;
        siteDevice['bleId'] = device.deviceId;
        // siteDevice['signal'] = device.rssi;
        siteDevice['signal'] = rssi;
        // siteDevice.signalIcon = this.getSignal(device.rssi);
        siteDevice.signalIcon = this.getSignal(rssi);
        siteDevice['near'] = true;
        siteDevice['rc'] = type === 'rayonics' ? true : false;
        siteDevice.isConnected = false;
        this.saveDevice(siteDevice);
        //If device already in list
        if (idx >= 0) {
          console.log('Device already exists, continue');
          continue;
        }
        //Add immediately device in result list, then ask device's tasks to api and refresh info
        // this.devices.push(siteDevice);
        // this.storeDevices();
        // this.changeRef.detectChanges();
        const tFilter = { where: { 'properties.status': 'pending' } };
        this.deviceTaskApi
          .deviceTaskControllerFind(siteDevice.id, JSON.stringify(tFilter))
          .toPromise()
          .then((t) => {
            console.log('TaskApi result:', t);
            siteDevice.tasksCount = t.length;
            //if device has no pending tasks, check in user's preference if
            //we must sync it anyway or not
            const syncWithoutTasksCondition =
              !!siteDevice.properties?.lastSeen && this.syncWithoutTasksSince >= 0
                ? new Date().getTime() - new Date(siteDevice.properties?.lastSeen)?.getTime() >=
                  this.syncWithoutTasksSince
                : true;
            if (siteDevice.tasksCount <= 0 && (!this.syncWithoutTasks || !syncWithoutTasksCondition)) return;
            //Avoid to sync without tasks each time we rescan
            // if(this.syncWithoutTasks && siteDevice.properties.lastSync < Date.now() - '10min') return;
            //else, start sync process
            // this.mustSync = true;
            console.log('Device has pending tasks,add it to syncQueue');
            const idx: number = this.syncQueue.findIndex((d) => d.bleId === siteDevice.bleId);
            if (idx >= 0) {
              this.syncQueue[idx] = siteDevice;
            } else {
              this.syncQueue.push(siteDevice);
            }
            console.log(
              'syncQueue:',
              JSON.stringify(
                this.syncQueue.map((d) => {
                  return { id: d.id, name: d.properties.name };
                })
              )
            );
            // this.changeRef.detectChanges();
            this.saveDevice(siteDevice);
            console.log('Device saved, current sync status:', this.syncing);
            //If sync not in progress, start syncing first device
            if (!this.syncing && this.autoSync) {
              this.sync(siteDevice);
            }
          });
      }
    }
    //INstall mode => display all unknown devices (rayonics/u-link) for installation
    if (this.installMode && !find) {
      const newDevice = device;
      const k = this.newDevices.findIndex((d) => d.deviceId === newDevice.deviceId);
      if (k >= 0) {
        console.log('Device already exists, continue');
        console.log('newDevices:', this.newDevices, 'device:', newDevice);
        return;
      }
      console.log('Add or refresh unknown device in list:', JSON.stringify(this.newDevices));
      // newDevice['bleId'] = device.id;
      newDevice['bleId'] = device.deviceId;
      // newDevice['signal'] = device.rssi;
      newDevice['signal'] = rssi;
      // newDevice.signalIcon = this.getSignal(device.rssi);
      newDevice.signalIcon = this.getSignal(rssi);
      newDevice['near'] = true;
      newDevice['rc'] = type === 'rayonics' ? true : false;
      // newDevice['serial'] = newDevice.rc ? newDevice.name : newDevice.bleId.replace(/:/g, '').toUpperCase();
      newDevice.serial = mac;
      newDevice.isConnected = false;
      console.log('add new device', newDevice);
      this.newDevices.push(newDevice);
      this.changeRef.detectChanges();
    }
    // this.ble.stopScan().then(() => this.bleScan());
  }

  orderList(): void {
    const sortBySignal = function (a, b) {
      return a.signal * -1 - b.signal * -1;
    };
    // const sortByStatus = function (a, b) {
    //   //Put connected device first
    //   if (a.isConnected && !b.isConnected) return -1;
    //   if (!a.isConnected && b.isConnected) return 1;
    //   //either both connected or disconnected
    //   if (a.syncEnd && !b.syncEnd) return -1;
    //   if (!a.syncEnd && b.syncEnd) return 1;
    //   //Else return 0
    //   return 0;
    // };
    const sortByStatus = function (a, b) {
      //Put connected device first
      if (a.isConnected && !b.isConnected) return -1;
      if (!a.isConnected && b.isConnected) return 1;
      //either both connected or disconnected
      if (a.syncEnd && !b.syncEnd) return 1;
      if (!a.syncEnd && b.syncEnd) return -1;
      //Else return 0
      return a.signal * -1 - b.signal * -1;
    };
    // if(this.orderAuto) {
    //   this.devices.sort(sortBySignal);
    //   this.devices.sort(sortByStatus);
    // }
    this.syncQueue.sort(sortBySignal);
    // this.devices.sort(sortBySignal);
    // this.changeRef.detectChanges();
    // this.devices.sort(sortByStatus);
    // this.devices = _.orderBy(this.devices, ['isConnected', 'syncEnd', 'signal'], ['desc', 'asc', 'desc']);
    this.devices = _.orderBy(this.devices, ['signal'], ['desc']);
    // this.changeRef.detectChanges();
  }

  async forceSync(device: any = null): Promise<void> {
    this.device = device;
    this.syncQueue = this.syncQueue.filter((dev) => dev.id !== device.id);
    // Place l'objet en première position
    this.syncQueue.unshift(device);

    console.log('Syncomponent - forceSync - syncQueue:', this.syncQueue);
    console.log('Syncomponent - forceSync - device:', device.bleId);
    if (this.bleService && this.device.isConnected) {
      console.log('Syncomponent - forceSync - disconnecting device');
      await this.bleService.disconnect();
    }
    this.sync(device)
      .then(() => console.log('Syncomponent => force sync done'))
      .catch((err) => {
        console.log('Syncomponent => error while forceSync device', this.device.id);
      });
  }

  async create(device: any = null): Promise<void> {
    console.log('Creating device', device);
    const brand = device.rc ? 'rayonics' : 'solupass';
    const url = `/device/create?brand=${brand}&serial=${device.serial}`;
    console.log(url);
    // this.router.navigate([url]);
    this.modalController.dismiss().then(() => {
      this.router.navigateByUrl(url);
    });
  }

  async install(device: any = null): Promise<void> {
    console.log('Installing device', device);
    let res;
    try {
      res = await this.deviceApi.deviceControllerSearchBySerial(device.serial).toPromise();
      console.log('Install api res:', res);
      if (!res) {
        console.log('Install error - error while getting api result');
        //warn user
      }
      // if(res. === 404 || !res.id) {
      if (!res.id) {
        console.log('device not found in our database', res);
        this.create(device);
        return;
      }
    } catch (e) {
      console.log('device not found in our database', res);
      this.create(device);
      return;
    }
    //device exists in database, redirect to install page
    let url = `/device/assignment?deviceId=${res.id}&serialNumber=${device.serial}`;
    if (this.siteId) {
      // const url = `/site/${this.siteId}/device/assignment?deviceId=${res.id}}`;
      url += `&siteId=${this.siteId}}`;
    }
    console.log('Navigate to', url);
    this.modalController.dismiss().then(() => {
      this.router.navigateByUrl(url);
    });
    // if (!device.rc) {
    //   console.log('Navigate to', url);
    //   this.modalController.dismiss().then(() => {
    //     this.router.navigateByUrl(url);
    //   });
    //   return;
    // }
    // this.syncing = true;
    // device.syncProgress = 0.1;
    // device.status = 'SYNC.CONNECT';
    // this.device = device;
    // //On rayonics we change key at every install
    // this.bleService = this.rayoBleService;
    // this.bleService.initDevice(device, this.ble);
    // console.log('Syncomponent - Install isConnect=', this.isConnected);
    // try {
    //   //conect without sync
    //   this.isConnected = await this.bleService.connect(false);
    // } catch (err) {
    //   console.log('Sync - Error while connecting to device:', err);
    //   this.isConnected = false;
    //   device.status = 'SYNC.ERROR';
    // }
    // device.isConnected = this.isConnected;
    // if (!this.isConnected) {
    //   this.bleDisconnected(this.device);
    //   console.log('Sync - change keys error: device disconnected', this.device);
    //   device.status = 'SYNC.ERROR';
    //   this.changeRef.detectChanges();
    //   return;
    // }
    // console.log('Sync - device is connected, subcribe to disconnect sub');
    // this.bleService.connectSubject.subscribe((res) => {
    //   console.log('Sync - Deconnexion subject:', res);
    //   if (this.bleService.taskAction === 'params') {
    //     //handle Bt connection loss following a firware update or reset cmd
    //     console.log('Syncomponent - connectSubject - lost connection after reset');
    //   } else {
    //     //reconnect??
    //     this.bleDisconnected(this.device);
    //     console.log('Sync - install change keys error, device disconnected');
    //     return;
    //   }
    // });
    // console.log('device', device.id, 'connected');
    // // this.cmdOpen.sendMessage();
    // device.status = 'SYNC.PROGRESS';
    // device.syncProgress = 0.2;
    // device.isConnected = true;
    // device.syncEnd = false;
    // this.saveNewDevice(device);
    // // this.changeRef.detectChanges();
    // console.log('sending command to device');
    // // this.bleService.openService.sendMessage();
    // this.bleService.syncSubject.subscribe((res) => {
    //   if (!res || typeof res !== 'object') {
    //     console.log('Sync subject error:', res);
    //     return;
    //   }
    //   if (res.device && res.device.id === device.id) {
    //     if (res.status === 'end') {
    //       device.status = 'SYNC.END';
    //       device.syncProgress = 1;
    //       device.syncEnd = true;
    //       this.syncing = false;
    //       // this.changeRef.detectChanges();
    //       //Sync tasks end, change keys
    //       this.bleService.rayChangeKeys();
    //       // this.bleService.disconnect();
    //       return;
    //     } else if (res.status === 'sync' && res.device.syncProgress) {
    //       device.syncProgress = res.device.syncProgress;
    //       this.saveNewDevice(device);
    //       return;
    //     } else if (res.status === 'keys') {
    //       device.status = 'SYNC.KEYSPROGRESS';
    //       this.saveNewDevice(device);
    //       return;
    //     } else if (res.status === 'keys_end') {
    //       device.status = 'SYNC.KEYSEND';
    //       this.saveNewDevice(device);
    //       //Keys changed, navigate to install menu
    //       console.log('Keys changed sucessfully! Navigate to', url);
    //       this.modalController.dismiss().then(() => {
    //         this.router.navigateByUrl(url);
    //       });
    //       return;
    //     } else if (res.status.match(/error/)) {
    //       device.status = 'SYNC.ERROR';
    //       this.syncing = false;
    //       console.log('Error during sync:', res.status);
    //       this.saveNewDevice(device);
    //       return;
    //     }
    //     //unknown syncSubject msg
    //     console.log('Syncomponent - Sync - Unknown synSubject msg or device changed', res);
    //   }
    // });
  }

  async sync(device: any = null): Promise<void> {
    this.syncing = true;
    device.syncProgress = 0.1;
    device.status = 'SYNC.CONNECT';
    this.device = device;
    console.log('Synchro sur : ', JSON.stringify(device));
    console.log(
      'Devices:',
      JSON.stringify(
        this.devices.map((d) => {
          return { id: d.id, name: d.properties.name };
        })
      )
    );
    // this.cmdOpen.setDevice(device, this.ble);
    // this.deviceService.setDevice(device);
    if (device['rc']) {
      this.bleService = this.rayoBleService;
      this.bleService.initDevice(device, this.bleClient);
    } else {
      this.bleService = this.ulinkBleService;
      this.bleService.initDevice(device, this.ble);
    }
    console.log('Syncomponent - Sync isConnect=', this.isConnected);

    // if (!this.isConnected) {
    //   // this.isConnected = await this.bleConnexion.bleConnexion(device);
    //   this.isConnected = await this.bleService.connect();
    //   device.isConnected = this.isConnected;
    //   // this.bleService.connexionService.deconnexion_subject.subscribe(
    //   //   (res) => {
    //   //     console.log('Device disconnected:', device);
    //   //     device.syncEnd = true;
    //   //     //sync next device in queue
    //   //   }
    //   // );
    // }

    try {
      this.isConnected = await this.bleService.connect();
    } catch (err) {
      console.log('Sync - Error while connecting to device:', err);
      this.isConnected = false;
      device.status = 'DEVICEBLE.CONNECTION.ERROR';
    }
    console.log('this.isConnected', this.isConnected);
    device.isConnected = this.isConnected;
    this.saveDevice(device);
    if (this.isConnected) {
      console.log('Sync - device is connected, subcribe to disconnect sub');
      this.bleService.connectSubject.subscribe((res) => {
        console.log('Sync - Deconnexion subject:', res);
        if (this.bleService.taskAction === 'params') {
          //handle Bt connection loss following a firware update or reset cmd
          console.log('Syncomponent - connectSubject - lost connection after reset');
        } else {
          //reconnect??
          this.bleDisconnected(this.device);
        }
      });
      if (!device['rc']) this.bleService.bleNotifications();
      console.log('device', device.id, 'connected');
      // this.cmdOpen.sendMessage();
      device.status = 'SYNC.PROGRESS';
      device.syncProgress = 0.2;
      device.isConnected = true;
      device.syncEnd = false;
      this.saveDevice(device);
      // this.changeRef.detectChanges();
      console.log('sending command to device');
      // this.bleService.openService.sendMessage();
      this.bleService.syncSubject.subscribe((res) => {
        if (!res || typeof res !== 'object') {
          console.log('Sync subject error:', res);
          return;
        }
        if (res.device && res.device.id === device.id) {
          console.log(
            'Sync subject update for device',
            device.id,
            ':',
            res,
            'devices:',
            JSON.stringify(
              this.devices.map((d) => {
                return { id: d.id, name: d.properties.name };
              })
            )
          );
          if (res.status === 'end') {
            device.status = 'SYNC.END';
            device.syncProgress = 1;
            device.syncEnd = true;
            this.syncing = false;
            // this.changeRef.detectChanges();
            this.bleService.disconnect();
            this.bleDisconnected(device);
            return;
          } else if (res.status === 'sync' && res.device.syncProgress) {
            device.syncProgress = res.device.syncProgress;
            this.saveDevice(device);
            return;
          } else if (res.status.match(/error/)) {
            device.status = 'SYNC.ERROR';
            this.syncing = false;
            // this.syncError = true;
            console.log('Error during sync:', res.status);
            this.saveDevice(device);
            this.bleDisconnected(device, true);
            return;
          }
          //unknown syncSubject msg
          console.log('Syncomponent - Sync - Unknown synSubject msg or device changed', res);
        }
      });
      //Désactiver sync tasks dans service RayoBle??
      if (!device['rc']) this.bleService.syncTasks();
    } else {
      //Device not connected, force disconnect and process next device in
      console.log('calling bleDisconnected() with device: ', this.device);
      this.syncQueue = this.syncQueue.filter((dev) => dev.id !== device.id);
      this.bleDisconnected(this.device, true);
    }
  }

  async update(device: any = null) {
    this.syncing = true;
    device.syncProgress = 0.1;
    device.status = 'SYNC.CONNECT';
    this.device = device;
    console.log('Update sur : ', device);
    // this.cmdOpen.setDevice(device, this.ble);
    // this.deviceService.setDevice(device);
    if (device['rc']) {
      // console.log('update unavaible on rayonics');
      this.bleService = this.rayoBleService;
      this.bleService.initDevice(device, this.bleClient);
      // setTimeout(() => {this.bleService.update();}, 3000);
      // return;
    } else {
      this.bleService = this.ulinkBleService;
      this.bleService.initDevice(device, this.ble);
    }
    console.log('Syncomponent - Update isConnect=', this.isConnected);

    // if (!this.isConnected) {
    //   // this.isConnected = await this.bleConnexion.bleConnexion(device);
    //   this.isConnected = await this.bleService.connect();
    //   device.isConnected = this.isConnected;
    //   // this.bleService.connexionService.deconnexion_subject.subscribe(
    //   //   (res) => {
    //   //     console.log('Device disconnected:', device);
    //   //     device.syncEnd = true;
    //   //     //sync next device in queue
    //   //   }
    //   // );
    // }
    // if(device['rc']) {
    //   this.bleService.update();
    //   return;
    // }
    try {
      this.isConnected = await this.bleService.connect(false);
    } catch (err) {
      console.log('Update - Error while connecting to device:', err);
      this.isConnected = false;
      device.status = 'SYNC.ERROR';
    }
    device.isConnected = this.isConnected;
    this.saveDevice(device);
    if (this.isConnected) {
      console.log('Update - device is connected, subcribe to disconnect sub');
      this.bleService.connectSubject.subscribe((res) => {
        console.log('Update - Deconnexion subject:', res);
        if (this.bleService.taskAction === 'update') {
          //handle Bt connection loss following a firware update or reset cmd
          console.log('Syncomponent - connectSubject - lost connection after update');
        } else {
          //reconnect??
          this.bleDisconnected(this.device);
        }
      });
      if (!device['rc']) this.bleService.bleNotifications();
      console.log('device', device.id, 'connected');
      // this.cmdOpen.sendMessage();
      device.status = 'SYNC.FWUPROGRESS';
      device.syncProgress = 0.2;
      device.isConnected = true;
      device.syncEnd = false;
      this.saveDevice(device);
      // this.changeRef.detectChanges();
      console.log('sending command to device');
      // this.bleService.openService.sendMessage();
      this.bleService.syncSubject.subscribe(async (res) => {
        console.log('syncsuject next:', res);
        if (!res || typeof res !== 'object') {
          console.log('Sync subject error:', res);
          return;
        }
        if (res.device && res.device.id === device.id) {
          if (res.status === 'update_end') {
            device.status = 'SYNC.FWUEND';
            device.syncProgress = 1;
            device.syncEnd = true;
            this.syncing = false;
            // this.changeRef.detectChanges();
            if (device['rc']) {
              await this.bleService.recreateDeviceConfig(this.device);
              this.sync(device);
              this.saveDevice(device);
              return;
            }
            this.bleService.disconnect();
            return;
          } else if (res.status === 'update' && res.device.syncProgress) {
            device.syncProgress = res.device.syncProgress;
            this.saveDevice(device);
            return;
          } else if (res.status.match(/error/)) {
            device.status = 'SYNC.FWUERROR';
            this.syncing = false;
            device.syncProgress = 1;
            console.log('Error during update:', res.status);
            // if(device.id === 541 || device.id === 548) {
            //   await this.bleService.recreateDeviceConfig(this.device);
            //   this.sync(device);
            //   return;
            // }
            this.saveDevice(device);
            return;
          }
          //unknown syncSubject msg
          console.log('Syncomponent - Update - Unknown synSubject msg or device changed', res);
        }
      });
      //Désactiver sync tasks dans service RayoBle??
      // if (!device['rc']) this.bleService.update();
      setTimeout(() => {
        this.bleService.update();
      }, 3000);
    } else {
      this.bleDisconnected(this.device);
    }
  }

  async open(device: any = null): Promise<void> {
    await this.disconnectBleDevices();
    await this.storage.set('device', device);
    const cachedAccesses = (await this.storage.get('accesses')).value;
    console.log('cachedAccesses', cachedAccesses);
    let allowed = false;
    cachedAccesses.forEach((access: any) => {
      if (access.properties?.devices.length) {
        access.properties.devices.forEach((dev: any) => {
          if (dev.id === device.id) {
            allowed = true;
          }
        });
      }
    });
    const role = this.userInfo.permissions?.sites[device['siteId']]?.role;
    if (['owner', 'admin'].includes(role)) {
      allowed = true;
    }
    console.log('allowed', allowed);
    if (allowed) {
      if (device['rc']) {
        let navigationExtras: NavigationExtras = {
          queryParams: {
            isConnected: this.isConnected,
            // device: JSON.stringify(device),
            deviceId: device.id,
            bleId: device.bleId,
            openDoor: false,
            auto_connect: true,
            replaceUrl: true,
          },
        };

        console.log('Ouverture Rayonics');

        this.modalCtrl.dismiss();

        if (role != 'user') {
          // console.log('a');
          console.log(device);

          this.router.navigate(['site/' + device.siteId + '/device/rayonics/open/' + device.id], navigationExtras);
        } else this.router.navigate(['site/' + device.siteId + '/device/rayonics/open/' + device.id], navigationExtras);
      } else {
        console.log('Ouverture sur : ', device);
        this.cmdOpen.setDevice(device, this.ble);

        if (!this.isConnected) this.isConnected = await this.bleConnexion.bleConnexion(device);

        if (this.isConnected) {
          this.cmdOpen.sendMessage();

          setTimeout(async () => {
            let navigationExtras: NavigationExtras = {
              queryParams: {
                isConnected: this.isConnected,
                // device: JSON.stringify(device),
                deviceId: device.id,
                bleId: device.bleId,
                openDoor: false,
                auto_connect: true,
                replaceUrl: true,
              },
            };

            // localStorage.setItem('device', JSON.stringify(device));

            this.modalCtrl.dismiss().then(() => {
              if (!device['rc']) {
                if (role != 'user')
                  this.router.navigate(['site/' + device.siteId + '/device/simpleuser/' + device.id], navigationExtras);
                else
                  this.router.navigate(['site/' + device.siteId + '/device/simpleuser/' + device.id], navigationExtras);
              }
            });
          }, 1750);
        }
      }
    } else {
      // Open alert with message "You're not allowed to open this device"
      const alert = await this.alertCtrl.create({
        message: this.translate.instant('SYNC.NOTALLOWEDERROR'),
        buttons: ['OK'],
      });

      await alert.present();
    }
  }

  async onAutoSyncToggleChange() {
    this.autoSync = !this.autoSync;
    //update user's preferences
  }

  // async syncBkp(device: any = null) {
  //   this.device = device;
  //   if (device['rc']) {
  //     let navigationExtras: NavigationExtras = {
  //       queryParams: {
  //         isConnected: this.isConnected,
  //         // device: JSON.stringify(device),
  //         deviceId: device.id,
  //         bleId: device.bleId,
  //         openDoor: false,
  //         auto_connect: true,
  //       },
  //     };

  //     console.log('Ouverture Rayonics');

  //     this.modalCtrl.dismiss();

  //     if (this.userInfo.permissions.sites[device['siteId']].role != 'user') {
  //       console.log('a');
  //       console.log(device);

  //       this.router.navigate(
  //         ['site/' + device.siteId + '/device/rayonics/open/' + device.id],
  //         navigationExtras
  //       );
  //     } else
  //       this.router.navigate(
  //         ['site/' + device.siteId + '/device/rayonics/open/' + device.id],
  //         navigationExtras
  //       );
  //   } else {
  //     console.log('Synchro sur : ', device);
  //     // this.cmdOpen.setDevice(device, this.ble);
  //     // this.deviceService.setDevice(device);
  //     this.bleService = this.ulinkBleService;
  //     this.bleService.initDevice(device, this.ble);

  //     if (!this.isConnected) {
  //       // this.isConnected = await this.bleConnexion.bleConnexion(device);
  //       this.isConnected = await this.bleService.connect();
  //       device.isConnected = this.isConnected;
  //       // this.bleService.connexionService.deconnexion_subject.subscribe(
  //       //   (res) => {
  //       //     console.log('Device disconnected:', device);
  //       //     device.syncEnd = true;
  //       //     //sync next device in queue
  //       //   }
  //       // );
  //     }

  //     if (this.isConnected) {
  //       console.log('Sync component - sync - device is connected');
  //       this.bleService.deconnexion_subject.subscribe((res) => {
  //         console.log('Sync - Deconnexion subject:', res);
  //         this.bleDisconnected(this.device);
  //       });
  //       this.bleService.bleNotifications();
  //       console.log('device', device.id, 'connected');
  //       // this.cmdOpen.sendMessage();
  //       device.syncProgress = 0;
  //       device.isConnected = true;
  //       device.syncEnd = false;
  //       this.saveDevice(device);
  //       this.changeRef.detectChanges();
  //       console.log('sending command to device');
  //       // this.bleService.openService.sendMessage();
  //       this.bleService.syncSubject.subscribe((res) => {
  //         console.log('Sync comp - syncSubject update:', JSON.stringify(res));
  //         if (!res || typeof res !== 'object')
  //           console.log('Sync subject error:', res);
  //         if (
  //           res.device &&
  //           res.device.id === device.id &&
  //           res.status === 'end'
  //         ) {
  //           console.log('Sync comp - syncSubject ended, disconnect device');
  //           device.syncEnd = true;
  //           this.syncing = false;
  //           this.bleService.disconnect();
  //           //end => should trigger deconnexion_subject
  //         }
  //       });
  //       this.bleService.syncTasks();

  //       // setTimeout(() => {
  //       //   let navigationExtras: NavigationExtras = {
  //       //     queryParams: {
  //       //       isConnected: this.isConnected,
  //       //       // device: JSON.stringify(device),
  //       //       deviceId: device.id,
  //       //       bleId: device.bleId,
  //       //       openDoor: false,
  //       //       auto_connect: true,
  //       //     },
  //       //   };

  //       //   localStorage.setItem('device', JSON.stringify(device));

  //       //   this.modalCtrl.dismiss().then(() => {
  //       //     if (!device['rc']) {
  //       //       if (
  //       //         this.userInfo.permissions.sites[device['siteId']].role != 'user'
  //       //       )
  //       //         this.router.navigate(
  //       //           ['site/' + device.siteId + '/device/simpleuser/' + device.id],
  //       //           navigationExtras
  //       //         );
  //       //       else
  //       //         this.router.navigate(
  //       //           ['site/' + device.siteId + '/device/simpleuser/' + device.id],
  //       //           navigationExtras
  //       //         );
  //       //     }
  //       //   });
  //       // }, 1750);
  //     }
  //   }
  // }

  syncAll() {
    this.router.navigate(['site/syncAll']);
  }

  isAdmin(device) {
    // console.log(device);
    /* if (device['rc']) {
       console.log("Rayonics !");
       return false;
     }*/

    if (this.userInfo.permissions.sites[device['siteId']].role == 'user') return false;
    return true;
  }

  isSuperAdmin() {
    const admins = [
      'fmrichiardi@groupe-inoveo.fr',
      'ngrange@u-link.fr',
      'jturello@u-link.fr',
      'apalermo@u-link.fr',
      'fm@fm.fr',
      'ngrange@groupe-inoveo.fr',
    ];
    return admins.includes(this.userInfo.email);
  }

  clearCache() {
    // this.storage.remove('devices');
    this.getDevices();
  }

  async refresh(): Promise<void> {
    await this.disconnectBleDevices();
    this.getDevices();
  }

  back() {
    this.modalCtrl.dismiss();
  }

  getSignal(value) {
    if (value <= -100) {
      return 'signal0.png';
    } else if (value > -100 && value <= -90) {
      return 'signal1.png';
    } else if (value > -90 && value <= -80) {
      return 'signal2.png';
    } else if (value > -80 && value <= -70) {
      return 'signal3.png';
    } else {
      return 'signal4.png';
    }
  }

  async storeScanDevices(expireDate: Date = new Date()) {
    if (!this.devices || !this.storage) return;
    const expire = Math.floor(expireDate.getTime() / 1000) + 30;
    const body = {
      expire: expire,
      value: this.devices,
    };
    this.storage
      .set('scanDevices', body)
      .then(() => console.log('Storage scan Devices updated'))
      .catch((err) => console.log('Error while storing scan devices:', err));
  }

  async storeDevices(expireDate: Date = new Date()) {
    if (!this.devices || !this.storage) return;
    const expire = Math.floor(expireDate.getTime() / 1000) + 600;
    const body = {
      expire: expire,
      value: this.siteDevices,
    };
    this.storage
      .set('devices', body)
      .then(() => console.log('Storage devices updated'))
      .catch((err) => console.log('Error while storing devices:', err));
  }

  saveDevice(device: any): boolean {
    console.log(
      'saveDevice - before order:',
      JSON.stringify(
        this.devices.map((d) => {
          return { id: d.id, bleId: d.bleId, name: d.properties.name, status: d.status, con: this.isConnected };
        })
      )
    );
    const idx = this.devices.findIndex((d) => d.id === device.id);
    if (idx < 0) {
      this.devices.push(device);
    } else {
      this.devices[idx] = device;
    }
    // this.storeDevices();
    this.storeScanDevices();
    this.orderList();
    console.log(
      'saveDevice - after order:',
      JSON.stringify(
        this.devices.map((d) => {
          return { id: d.id, name: d.properties.name, status: d.status, con: this.isConnected };
        })
      )
    );
    // if (!this.changeRef['destroyed']) {
    //   this.changeRef.detectChanges();
    // }
    try {
      this.changeRef.detectChanges();
    } catch (err) {
      console.log('Synccomponent - saveDevice', err);
    }
    return true;
  }

  saveNewDevice(device: any): boolean {
    const idx = this.newDevices.findIndex((d) => d.id === device.id);
    if (idx < 0) {
      this.newDevices.push(device);
    } else {
      this.newDevices[idx] = device;
    }
    try {
      this.changeRef.detectChanges();
    } catch (err) {
      console.log('Synccomponent - saveNewDevice', err);
    }
    return true;
  }

  bleDisconnected(device, syncFailed = false) {
    //remove current device from syncQueue
    this.syncQueue = this.syncQueue.filter((dev) => dev.bleId !== device.bleId);
    if (syncFailed) {
      // Place l'objet en dernière position
      this.syncQueue.push(device);
      this.syncing = false;
    }
    this.isConnected = false;
    device.isConnected = false;
    //save current device info and reorder list and queue
    this.saveDevice(device);
    // this.changeRef.detectChanges();
    //next device
    console.log(
      'Processing next device in queue:',
      JSON.stringify(
        this.syncQueue.map((d) => {
          return { id: d.id, name: d.properties.name };
        })
      )
    );
    // this.syncQueue.shift();
    if (this.syncQueue.length > 0 && !this.syncing && this.autoSync) {
      this.sync(this.syncQueue[0]);
    }
  }

  shouldDisplaySyncButton(device): boolean {
    const condition =
      this.isAdmin(device) &&
      ((device.tasksCount && (!device.syncEnd || device?.status?.match(/ERROR/))) ||
        (this.syncWithoutTasks && device?.status?.match(/ERROR/)));
    // console.log('Device', device.id, '->Should display sync button:', condition);
    return condition;
  }

  upgradeAvailable(device): boolean {
    //@future -> enable to all Admins and check dynamic FW version
    const condition =
      // this.isAdmin(device) &&
      device.rc &&
      device.properties.config?.rfidFwVersion === 'RCHWV1.0.1' &&
      device.properties.config?.mainFwVersion !== 'RCSWV1.3.0';
    // console.log('Device', device.id, '->Should display sync button:', condition);
    return condition;
  }

  async disconnectBleDevices(): Promise<void> {
    for (const i in this.devices) {
      const device = this.devices[i];
      if (device.isConnected) {
        if (device['rc']) {
          this.bleService = this.rayoBleService;
          this.bleService.initDevice(device, this.bleClient);
        } else {
          this.bleService = this.ulinkBleService;
          this.bleService.initDevice(device, this.ble);
        }
        this.bleService.disconnect();
      }
    }
  }
}
